import IconGoogle from '@icons/Google'
import IconStar from '@icons/Star'
import IconStarHalf from '@icons/StarHalf'
import IconVerified from '@icons/Verified'

import * as S from './Testimonial.styled'

export const renderRating = (rating) => {
  const items = []
  for (let i = 0; i < Math.floor(rating); i++) {
    items.push(<IconStar width={20} height={20} />)
  }
  if (rating % 1 !== 0) {
    items.push(<IconStarHalf percent={rating % 1} />)
  }
  return items
}

const renderReview = (testimonial_source) => {
  return (
    <S.VerifyWrap>
      {testimonial_source === 'Google Maps' ? (
        <>
          <IconGoogle /> Verified Review
        </>
      ) : (
        <>
          <IconVerified /> Verified Review{' '}
          {testimonial_source ? `- ${testimonial_source}` : ''}
        </>
      )}
    </S.VerifyWrap>
  )
}

const Testimonial = ({ testimonial }) => {
  return (
    <S.Testimonial>
      {testimonial.rating && (
        <S.TestimonialRating>
          {renderRating(testimonial.rating)}{' '}
          <span>{testimonial.rating.toFixed(1)}</span>
        </S.TestimonialRating>
      )}
      <S.TestimonialAuthor>
        {testimonial.name}
        {testimonial.reviewer_role && ` - ${testimonial.reviewer_role}`}
      </S.TestimonialAuthor>
      <S.TestimonialDes>{testimonial.copy}</S.TestimonialDes>
      <S.TestimonialFooter>
        {renderReview(testimonial?.testimonial_source)}
      </S.TestimonialFooter>
    </S.Testimonial>
  )
}

export default Testimonial
